import UploadLinesCont from '../../../../components/Purchasing/RFQ/Lines/upload/UploadLinesCont'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import React, { Fragment } from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button, Modal } from 'antd'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'

const CheckboxTable = checkboxHOC(CustomTable)

function List(props) {
  const {
    list,
    isUpdatable,
    fetch,
    fetching,
    onShow,
    isSelected,
    toggleSelection,
    tableRef,
    selection,
    removeSelection,
    removing,
    selectAll,
    rfq,
  } = props
  const { visible, onShow: showModal, onCancel: hideModal } = useModalShow()

  const checkboxProps = {
    selectType: 'checkbox',
    isSelected,
    toggleSelection,
    selectAll,
  }

  const columns = [
    {
      Header: 'No',
      accessor: 'no',
      width: 100,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Name', accessor: 'name', width: 300 },
    {
      Header: 'Description',
      accessor: 'description',
      hideable: true,
      hideDefault: false,
    },
    { Header: 'Unit', accessor: 'unit', width: 100 },
    { Header: 'UOM', accessor: 'uom.code', width: 100 },
    {
      Header: 'OEM Name',
      accessor: 'materials.oem.name',
      width: 200,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'OEM No',
      accessor: 'materials.oem.no',
      width: 200,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'DWG No',
      accessor: 'drawing_no',
      width: 200,
      hideable: true,
      hideDefault: false,
    },
  ]

  return (
    <>
      <Modal
        visible={visible}
        title={'Upload Lines'}
        onCancel={hideModal}
        footer={null}
        destroyOnClose={true}
        width={'75%'}>
        <UploadLinesCont rfq={rfq} fetchLines={() => fetch()} hideModal={hideModal} />
      </Modal>
      <CheckboxTable
        {...checkboxProps}
        withRef={tableRef}
        data={list}
        defaultPageSize={20}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        CreateButton={() => (
          <>
            <Button type={'primary'} size="small" icon={'plus'} onClick={onShow} disabled={!isUpdatable}>
              New
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              type="upload"
              size="small"
              icon={'plus'}
              onClick={showModal}
              disabled={!isUpdatable}>
              Upload
            </Button>
            <Button
              size={'small'}
              type={'danger'}
              loading={removing}
              onClick={removeSelection}
              disabled={selection.length === 0 || !isUpdatable}
              style={{ marginLeft: '10px' }}>
              Remove Selection
            </Button>
          </>
        )}
        defaultSorted={[
          {
            id: 'no',
            desc: false,
          },
        ]}
        columns={columns}
      />
    </>
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
